import createAxios from 'config/axios'

const URL = '/registrar/v2/customers/bankaccounts'
const getAccounts = () => createAxios.get(URL)
export default getAccounts
